import script from "./elementlist.vue?vue&type=script&lang=ts&setup=true"
export * from "./elementlist.vue?vue&type=script&lang=ts&setup=true"

import "./elementlist.vue?vue&type=style&index=0&id=1c33e84c&lang=scss&scoped=true"
import "./elementlist.vue?vue&type=style&index=1&id=1c33e84c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c33e84c"]])

export default __exports__